import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import './Onboarding.css';

// One-time welcome carousel shown to brand-new accounts. Visibility is decided
// by the parent (App): it only mounts when `user.onboarded` is false. Finishing
// or skipping calls completeOnboarding(), which flips the flag for good.
const SLIDES = [
  {
    icon: '📦',
    title: 'Track your stock',
    body: 'Add products once and ShopBook keeps a running count for you. Stock goes down with every sale and up with every purchase — no manual tallying.',
  },
  {
    icon: '🧾',
    title: 'Sell in seconds',
    body: 'Ring up a sale from your phone, cash or credit. Receipts, totals and profit are worked out automatically as you go.',
  },
  {
    icon: '🤝',
    title: 'Never lose a debt',
    body: 'Record who owes you and how much. ShopBook rates each customer from their payment history, so you know who to trust.',
  },
  {
    icon: '📡',
    title: 'Works fully offline',
    body: 'No signal, no problem. Everything you do is saved on your device and syncs the moment you are back online.',
  },
];

export default function Onboarding() {
  const { user, business, completeOnboarding } = useAuth();
  const [step, setStep] = useState(0);

  const isFirst = step === 0;
  const isLast  = step === SLIDES.length - 1;
  const slide   = SLIDES[step];
  const firstName = (user?.name || '').trim().split(/\s+/)[0];

  const next = () => (isLast ? completeOnboarding() : setStep((s) => s + 1));
  const back = () => setStep((s) => Math.max(0, s - 1));

  return (
    <div className="ob-overlay" role="dialog" aria-modal="true" aria-label="Welcome to ShopBook">
      <div className="ob-card">
        <button className="ob-skip" onClick={completeOnboarding}>Skip</button>

        {isFirst && (
          <p className="ob-welcome">
            Welcome{firstName ? `, ${firstName}` : ''} 👋
          </p>
        )}

        <div className="ob-icon" aria-hidden="true">{slide.icon}</div>
        <h2 className="ob-title">
          {isFirst ? `${business?.name || 'Your shop'} is ready` : slide.title}
        </h2>
        <p className="ob-body">{isFirst ? SLIDES[0].body : slide.body}</p>

        <div className="ob-dots" aria-hidden="true">
          {SLIDES.map((_, i) => (
            <span key={i} className={`ob-dot ${i === step ? 'is-active' : ''}`} />
          ))}
        </div>

        <div className="ob-actions">
          {!isFirst && (
            <button className="btn-ghost ob-btn" onClick={back}>Back</button>
          )}
          <button className="btn-primary ob-btn ob-btn-next" onClick={next}>
            {isLast ? "Let's go" : 'Next'}
          </button>
        </div>
      </div>
    </div>
  );
}
